import React from 'react';
import { Th as ChakraTh } from '@chakra-ui/react';

export const Th = props => <ChakraTh {...props} />;
